import {makeStyles} from '@material-ui/core/styles';
import React, {useState, useEffect} from 'react';
import globalContext from '../../../config/context';
import Api from '../../../config/api';
import proj4 from 'proj4';
import Config from '../../../config/config';

const useStyles = makeStyles((theme) => ({
  root: {},
}));

const useHook = (props) => {
  const classes = useStyles();
  const {useAppContext} = globalContext;
  const [{pencarian}, {setPencarian, setAlert, setLoading}] = useAppContext();
  const {mapRef} = props;

  //select Kecamatan--------------------------------------------------------------------------------------------------
  const [kecamatan, setKecamatan] = useState('');
  const [kecamatanOptions, setKecamatanOptions] = useState('');
  const handleKecamatan = (event, value) => {
    // setKecamatan(event.target.value); -- FormControl
    setKecamatan(value ? value.kd_kecamatan : '');
    setKecamatanOptions(value);
  };
  const [itemKecamatan, setItemKecamatan] = useState([]);
  useEffect(() => {
    Api.get('gis/ref/kecamatan').then(function (response) {
      if (response) {
        if (response.data) {
          setItemKecamatan(response.data);
        }
      }
    });
  }, []);

  useEffect(() => {
    Api.get('gis/ref/kecamatan').then(function (response) {
      if (response) {
        if (response.data) {
          for (const item of response.data) {
            if (String(item.kd_kecamatan) === String(kecamatan)) {
              setKecamatanOptions(item);
            }
          }
        }
      }
    });
  }, [kecamatan]);

  //Chart Status Pembayaran Pajak--------------------------------------------------------------------------------------
  useEffect(() => {
    if (typeof pencarian.state !== 'undefined') {
      if (pencarian.state === 'status_pembayaran') {
        onRealisasi();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pencarian, kecamatan]);

  const [realisasi, setRealisasi] = useState('');
  const onRealisasi = () => {
    const map = mapRef.current.leafletElement;
    const center = proj4(Config.proj4def, [map.getCenter().lng, map.getCenter().lat]);

    Api.get('gis/chart/status_pembayaran', {
      tahun: pencarian.tahun,
      kec: kecamatan,
      latitude: center[1],
      longitude: center[0],
    }).then(function (response) {
      // console.log(response.data);
      if (response) {
        if (response.data) {
          setRealisasi(response.data);
        }
      }
    });
  };

  return [{realisasi}, {kecamatan, setKecamatan, kecamatanOptions, setKecamatanOptions, handleKecamatan, itemKecamatan}];
};

export default useHook;
